
import { Moon, Sun } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useTheme } from "@/components/theme/theme-provider"
import { useAuth } from "@/components/auth/AuthProvider"
import { supabase } from "@/integrations/supabase/client"
import { toast } from "sonner"
import { useEffect } from "react"

export function ModeToggle() {
  const { setTheme, theme } = useTheme()
  const { user } = useAuth()

  // Apply theme class to document element when theme changes
  useEffect(() => {
    if (theme) {
      document.documentElement.className = theme;
      document.documentElement.style.colorScheme = theme;
    }
  }, [theme]);

  const handleThemeChange = async (newTheme: string) => {
    setTheme(newTheme)
    document.documentElement.className = newTheme;
    document.documentElement.style.colorScheme = newTheme;
    
    if (user?.id) {
      try {
        const { error } = await supabase
          .from('user_profiles')
          .update({ theme_preference: newTheme })
          .eq('id', user.id)

        if (error) throw error
      } catch (error) {
        console.error('Error saving theme preference:', error)
        toast.error('Failed to save theme preference')
      }
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="h-9 w-9 flex items-center justify-center p-0 rounded-full"
        >
          <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0 text-foreground dark:text-white" />
          <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 text-foreground dark:text-white" />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="dark:text-white">
        <DropdownMenuItem onClick={() => handleThemeChange("light")} className="dark:text-white dark:hover:text-white">
          Light
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleThemeChange("dark")} className="dark:text-white dark:hover:text-white">
          Dark
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
